import { createGlobalStyle } from 'styled-components';
import { resetCss } from './resetCss';
import { BREAKPOINTS, FONT_SIZE, FONT_WEIGHT, media } from './themes/constants';
import {
  lightThemeVariables,
  darkThemeVariables,
  commonThemeVariables,
  antOverrideCssVariables,
} from './themes/themeVariables';

export default createGlobalStyle`
  :root {
    ${commonThemeVariables};
    ${antOverrideCssVariables};
  } 

  ${resetCss}

  &&& .actions-list-dropdown > .ant-dropdown-menu-item {
      padding-top: 4px !important;
      padding-bottom: 4px !important;
  }

  &&& .ant-table-wrapper .ant-table-ping-right:not(.ant-table-has-fix-right)  .ant-table-container::after {
      box-shadow: inset -10px 0 8px -8px rgba(0, 0, 0, .45);
  }

  &&& .ant-table-wrapper .ant-table-ping-left:not(.ant-table-has-fix-left) .ant-table-container::before {
      box-shadow: inset 10px 0 8px -8px rgba(0, 0, 0, .45);
  }

  &&& .ant-divider {
    border-color: rgba(0,0,0,0.09);
  }

  &&& .ant-tooltip > .ant-tooltip-arrow {
    bottom: 1px !important;
  }

  .no-select {
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  [data-theme='light'],
  :root {
    ${lightThemeVariables}
  }

  [data-theme='dark'] {
    ${darkThemeVariables}
  }



  [data-no-transition] * {
    transition: none !important;
  }
  
  .range-picker {
    & .ant-picker-panels {
      @media only screen and ${media.xs} and (max-width: ${BREAKPOINTS.md - 0.02}px) {
        display: flex;
        flex-direction: column;
      }
    }
  }

  .search-overlay {
    box-shadow: var(--box-shadow);

    @media only screen and ${media.xs} and (max-width: ${BREAKPOINTS.md - 0.02}px)  {
      width: calc(100vw - 16px);
      max-width: 600px;
    }

    @media only screen and ${media.md} {
      width: 323px;
    }
  }

  a {
    color: var(--primary-color);
    &:hover,:active {
      color: var(--ant-primary-color-hover);
    }
  }
  
  .ant-picker-cell {
    color: var(--text-main-color);
  }

  .ant-picker-cell-in-view .ant-picker-calendar-date-value {
    color: var(--text-main-color);
    font-weight: ${FONT_WEIGHT.bold};
  }

  .ant-light-dropdown-popup {
    background-color: var(--highlighting-dark-color);
    color: var(--text-dark-color);

    .ant-select-item {
      background-color: var(--highlighting-dark-color);  
      color: var(--text-dark-color);
    }
  }

  .ant-light-dropdown {
    && .ant-select-selection-item {
      color: var(--text-dark-color);
    }
  }

  // Multi-line dropdown support for license types
  .license-multiline-dropdown {
    .ant-select-item {
      white-space: normal !important;
      min-height: auto !important;
      line-height: 1.4 !important;
      padding: 8px 12px !important;
      height: auto !important;
    }
    
    .ant-select-item-option-content {
      white-space: normal !important;
    }
  }

  .ant-picker svg {
    color: var(--text-light-color);
  }

  .ant-modal-close:focus,.ant-modal-close:hover {
    color: var(--icon-color);
    opacity: 0.5;
  }

  // notifications start
  .ant-notification-notice {
    width: calc(36rem + 15px);
    padding: 2rem;
    min-height: 6rem;

    /* Compact: a one-line generic message (title-only type) plus a small reference line. */
    &.notification-with-copy {
      padding: 1.25rem 1.5rem;
      min-height: auto;

      .title {
        padding-right: 5rem;
      }

      .ant-notification-notice-with-icon .ant-notification-notice-description {
        /* Aligned with the title text: message margin + title margin. */
        margin-left: 3.5625rem;
        margin-top: 0.25rem;
      }

      .description {
        font-size: ${FONT_SIZE.xs};
        font-weight: ${FONT_WEIGHT.regular};
        line-height: 1.25rem;
        word-break: break-all;
      }
    }

    .ant-notification-notice-with-icon .ant-notification-notice-message {
      margin-bottom: 0;
      margin-left: 2.8125rem;
    }

    .ant-notification-notice-with-icon .ant-notification-notice-description {
      margin-left: 4.375rem;
      margin-top: 0;
    }

    .ant-notification-notice-icon {
      font-size: 2.8125rem;
      margin-left: 0
    }

    .ant-notification-notice-close {
      top: 1.25rem;
      right: 1.25rem;
    }

    .ant-notification-notice-close-x {
      display: flex;
      font-size: 0.9375rem;
    }

    .notification-without-description {
      .ant-notification-notice-close {
        top: 1.875rem;
      }
      .ant-notification-notice-with-icon .ant-notification-notice-description  {
        margin-top: 0.625rem;
      }
    }
    
    .title {
      font-size: ${FONT_SIZE.xxl};
      /* min-height, not height: a wrapping title overflows a fixed box. */
      min-height: 3rem;
      line-height: 1.3;
      margin-left: 1.5rem;
      display: flex;
      align-items: center;
      font-weight: ${FONT_WEIGHT.bold};

      &.title-only {
        /* Not var(--text-main-color): the background is #FFE2E2 in both themes. */
        color: #404040;
        font-size: ${FONT_SIZE.md};
        min-height: 2rem;
        line-height: 1.4;
        margin-left: 0.75rem;
        font-weight: ${FONT_WEIGHT.semibold};
      }
  }
  
    .description {
      color: #404040;
      font-size: ${FONT_SIZE.md};
      font-weight: ${FONT_WEIGHT.semibold};
      line-height: 1.375rem;
    }
  
    &.ant-notification-notice-success {
      border: 1px solid var(--success-color);
      background: var(--notification-success-color);
      
      .title {
        color: var(--success-color);
      }
    }
  
    &.ant-notification-notice-info {
      border: 1px solid var(--primary-color);
      background: var(--notification-primary-color);
  
      .title {
        color: var(--primary-color);
      }
    }
  
    &.ant-notification-notice-warning {
      border: 1px solid var(--warning-color);
      background: var(--notification-warning-color);
  
      .title {
        color: var(--warning-color);
      }
    }
  
    &.ant-notification-notice-error {
      border: 1px solid var(--error-color);
      background: var(--notification-error-color);
  
      .title {
        color: var(--error-color);
      }
    }
  
    .success-icon {
      color: var(--success-color);
    }
  
    .info-icon {
      color: var(--primary-color);
    }
  
    .warning-icon {
      color: var(--warning-color);
    }
  
    .error-icon {
      color: var(--error-color);
    }
  }
  
  &&& .ant-menu-inline, .ant-menu-vertical {
    border-right: 0;
  }
  // notifications end

  // Collapsed sider menu popup renders in a white portal on light theme,
  // making the white sider text invisible. Override text to a readable dark color.
  [data-theme='light'] .ant-menu-submenu-popup > .ant-menu {
    .ant-menu-item,
    .ant-menu-submenu-title,
    .ant-menu-submenu-expand-icon,
    .ant-menu-submenu-arrow,
    span[role='img'],
    a {
      color: var(--text-main-color);
      fill: var(--text-main-color);

      path {
        stroke: var(--text-main-color);
      }
    }

    img.ant-menu-item-icon {
      filter: none;
    }
  }
`;
